import React from 'react';
import { LayoutDashboard, Settings, Package, BadgeDollarSign, Waypoints, ListChecks, PanelRightOpen, Users, ChartArea, BanknoteArrowUp } from 'lucide-react';

interface NavItem {
  path: string;
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  label: string;
  tab: string;
}

interface SidebarProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
}

const navItems: NavItem[] = [
  {
    path: 'overview',
    icon: LayoutDashboard,
    label: 'Overview',
    tab: 'overview'
  },
  {
    path: 'packages',
    icon: Package,
    label: 'Packages',
    tab: 'packages'
  },
  {
    path: 'subscriptions',
    icon: ListChecks,
    label: 'Subscriptions',
    tab: 'subscriptions'
  },
  {
    path: 'payments',
    icon: BadgeDollarSign,
    label: 'Payments',
    tab: 'payments'
  },
  {
    path: 'gateways',
    icon: Waypoints,
    label: 'Payment Gateways',
    tab: 'gateways'
  },
  {
    path: 'users',
    icon: Users,
    label: 'Users',
    tab: 'users'
  },
  {
    path: 'analytics',
    icon: ChartArea,
    label: 'Analytics',
    tab: 'analytics'
  },
  {
    path: 'forex',
    icon: BanknoteArrowUp,
    label: 'Forex',
    tab: 'forex'
  },
  {
    path: 'settings',
    icon: Settings,
    label: 'Settings',
    tab: 'settings'
  },
];

const Sidebar: React.FC<SidebarProps> = ({ activeTab, onTabChange }) => {
  return (
    <aside className="fixed inset-y-0 left-0 w-64 shadow-lg border-r border-gray-500">
      <div className="h-10 flex items-center px-4 w-fit border-b border-gray-500 mx-auto my-8">
        <PanelRightOpen className="w-6 h-6 text-white"/>
      </div>

      <nav className="mt-16 ml-6">
        <ul className="space-y-8">
          {navItems.map((item) => (
            <li key={item.path}>
              <button 
                onClick={() => onTabChange(item.tab)}
                className={`flex items-center gap-x-1 px-4 py-3 text-sm hover:scale-105 rounded-lg transition-colors ${
                  activeTab === item.tab ? 'bg-transparent' : ''
                }`}
              >
                <item.icon className={`w-6 h-6 ${activeTab === item.tab ? 'text-white' : 'text-gray-500'}`} />
                <span className={`ml-3 ${activeTab === item.tab ? 'text-white' : 'text-gray-500'}`}>{item.label}</span>
              </button>
            </li>
          ))}
        </ul>
      </nav>
    </aside>
  );
};

export default Sidebar;
